import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "aw-sl",
  style: {"font-size":"1em !important"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MAFormModal = _resolveComponent("MAFormModal")

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode("div", {
      id: "aw--c",
      style: _ctx.themeCss
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_MAFormModal, {
          ref: "maModal",
          ma: _ctx.ma
        }, null, 8, ["ma"])
      ])
    ], 4)
  ]))
}